export const LIST_NOTICES = 'LIST_NOTICES';
export const LIST_NOTICES_SUCCESS = 'LIST_NOTICES_SUCCESS';
export const LIST_NOTICES_FAILED = 'LIST_NOTICES_FAILED';
